<template>
    <div class="selectCourt">
        <MyTitle theTitle="请选择案由"/>
            <div class="fd-select-court">
                <span>选择案由：</span>
                <span class="red-font">{{info.checkedFy}}</span>
            </div>
        <div class="fd-com-scroll">
            <!-- disabled -->
            <van-tabs v-model="active">
                <van-tab title="一级案由">
                    <ul class="fd-court-list">
                        <li v-for="(item,index) in info.gjfyList" :key="index">
                            <span @click="gjfyListFun(item)">{{item.name}}</span>
                        </li>
                    </ul>
                </van-tab>
                <van-tab title="二级案由" :disabled="!info.zjfyList.length">
                    <ul class="fd-court-list">
                        <li v-for="(item,index) in info.zjfyList" :key="index">
                            <span @click="zjfyListFun(item)">{{item.name}}</span>
                        </li>
                    </ul>
                </van-tab>
                <van-tab title="三级案由" :disabled="!info.sjfyList.length">
                    <ul class="fd-court-list">
                        <li v-for="(item,index) in info.sjfyList" :key="index">
                            <span @click="sjfyListFun(item)">{{item.name}}</span>
                        </li>
                    </ul>
                </van-tab>
                <van-tab title="四级案由" :disabled="!info.sijiAy.length">
                    <ul class="fd-court-list">
                        <li v-for="(item,index) in info.sijiAy" :key="index">
                            <span @click="sijiAyFun(item)">{{item.name}}</span>
                        </li>
                    </ul>
                </van-tab>
            </van-tabs>
        </div>
        <div class="fd-com-btn-container">
            <van-button
                type="info"
                round
                @click="sureBth">
                确定
            </van-button>
        </div>
    </div>
</template>

<script>
    import MyTitle from '../../components/common/myTitle'

    export default {
        data() {
            return {
                info: {
                    checkedFy: "",
                    checkedFyId: "",
                    selectAyId: '',
                    cId: "",
                    gjfyList: [],
                    zjfyList: [],
                    sjfyList: [],
                    sijiAy: [],
                },
                active: 0,
                ayListAll: {}
            }
        },
        components: {
            MyTitle,
        },
        methods: {
            creatData() {
                let  selectay = sessionStorage.getItem('selectay')
                let  selectayId = sessionStorage.getItem('selectayId')
                this.info.checkedFy = ''
                this.info.checkedFyId = ''
                if(selectay){
                    this.info.checkedFy =  selectay.replace(/"/g, '')
                    this.info.checkedFyId =  selectayId.replace(/"/g, '')
                }
                let ajlx = sessionStorage.getItem("nAjlx")
                //let cAyxzxw = sessionStorage.getItem("Aysz") || 1

                let cAhNf =  sessionStorage.getItem("cAhNf")||2020
                var key=(cAhNf>=2021)?2021:2020;

                console.log('--creatData 000',selectay);
                console.log('--creatData 111',selectayId);
                console.log('--creatData 222',ajlx);
                //console.log('--creatData 333',cAyxzxw);
                console.log('--creatData 444',cAhNf);
                console.log('--creatData 555',key);



                /*this.$axios.get('ssbq/api/bqsqs/ay?ajlx=' + ajlx + '&xzlx=' + cAyxzxw).then(res => {
                    this.ayData = res.data
                    this.active=0
                    //给一级案由赋值
                    this.info.gjfyList = this.ayData[0].children
                    this.info.zjfyList = []
                    this.info.sjfyList = []
                    this.info.sijiAy = []
                })*/

                console.log('--取值',cAhNf,ajlx);
                var setV=()=>{
                    //sessionStorage.setItem('ayListAll',JSON.stringify(this.ayListAll));
                    this.active=0
                    this.info.gjfyList = this.ayListAll[key][ajlx==6?61:ajlx][0].children;

                    this.info.zjfyList = []
                    this.info.sjfyList = []
                    this.info.sijiAy = []
                };

                let ayListAll = sessionStorage.getItem('ayListAll');
                console.log('--ayListAll 000',ayListAll);
                if(ayListAll){
                    this.ayListAll=JSON.parse(ayListAll);
                    setV();
                }else{
                    this.$axios.get('ssbq/api/bqsqs/new/ay').then(res => {
                        console.log('--res 000', res);
                        this.ayListAll = res.data;
                        setV();
                    })
                }

            },
            /**
             * 一级案由点击事件
             */
            gjfyListFun(courtName) {
                this.info.checkedFy = courtName.name
                this.info.selectAyId = courtName.id
                this.info.zjfyList = courtName.children
                this.info.sjfyList = []
                this.info.sijiAy = []

            },
            /**
             * 二级案由点击事件
             */
            zjfyListFun(courtName) {
                this.info.checkedFy = courtName.name
                this.info.selectAyId = courtName.id
                this.info.sjfyList = courtName.children
                this.info.sijiAy = []
            },
            /**
             * 三级案由列表点击事件
             */
            sjfyListFun(courtName) {
                this.info.checkedFy = courtName.name
                this.info.selectAyId = courtName.id
                this.info.sijiAy = courtName.children
            },
            /**
             * 四级案由列表点击事件
             */
            sijiAyFun(courtName) {
                this.info.checkedFy = courtName.name
                this.info.selectAyId = courtName.id
            },
            //点击确定按钮
            sureBth() {
                sessionStorage.setItem('selectay', JSON.stringify(this.info.checkedFy));
                sessionStorage.setItem('selectayId', JSON.stringify(this.info.selectAyId));
                this.$router.go(-1)
            }
        },
        beforeRouteEnter (to, from, next){
            next(vm => {
                vm.creatData();
            })
        }
    }
</script>

<style lang="less" scoped>
    .selectCourt {
        width: 100%;
        height: 100%;
    }

    .fd-com-scroll {
        background: #fff;
    }

    .fd-select-court {
        box-sizing: border-box;
        padding: 0 10px;
        line-height: 50px;
        display: flex;
    }

    .fd-xzfy-top {
        display: flex;
        box-sizing: border-box;
        padding: 0 20px;
        justify-content: space-between;

        > button {
            background: #fff;
            cursor: pointer;
        }
    }

    .fd-court-list {
        width: 100%;
        height: 70%;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0 10px;

        > li {
            width: 100%;
            height: 50px;
            line-height: 50px;
            cursor: pointer;
            border-bottom: 1px solid #eaeaea;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .red-font {
        color: red;
        display: block;
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .van-tabs {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .van-tabs__content {
        flex: 1;
        overflow-y: scroll;
    }
</style>
